// The selected school may carry read-only coverage metadata. Only the existing
// artwork input fields cross this boundary; coverage grants no generation rights.
export function artworkCreationPayload({title,tier,assigned,school,championshipId,requestedTool}) {
  return {title,tier,ownerId:assigned||undefined,companyId:school?.id||'',championshipId:championshipId||'',spec:{schoolName:school?.name||(requestedTool==='upload'?'':title)}}
}
